export const PLAYLISTS_STATES = [
    {
        code: 'PUBLIC',
        name: 'state.default.code.public'
    }, {
        code: 'PRIVATE',
        name: 'state.default.code.private'
    }
]
